export enum EnumCardSelected {
  FISIC = 'F',
  OFFICE = 'O',
  NO_CARD_SELECTED = ''
}
